import React from 'react';
import { Button, Box } from '@material-ui/core';
import { PeopleOutlined, KeyboardArrowDownRounded, Schedule as ScheduleIcon } from '@material-ui/icons';
import { unpackToTime } from '@campfire/hot-date';
import { useRosterStatusStyles } from './RosterTableStyles';
import { useCampfireTheme } from '../../../../../../theme/useCampfireTheme';

interface Props {
  color?: string;
  text: string;
  onClick: (arg: any) => void;
  disabled?: boolean;
  hasLeaveConflict?: boolean;
  publishedSessionIds?: string[];
  hasCustomTimes?: boolean;
  customStartTime?: string | null;
  customEndTime?: string | null;
}

function formatShortTime(time: string | null | undefined): string {
  if (!time) return '';
  const dt = unpackToTime(time);
  return dt.minute === 0 ? dt.toFormat('ha').toLowerCase() : dt.toFormat('h:mma').toLowerCase();
}

export function RosterStatus({
  text,
  onClick,
  color = 'tomato',
  disabled,
  hasLeaveConflict,
  hasCustomTimes,
  customStartTime,
  customEndTime,
}: Props) {
  const classes = useRosterStatusStyles({ color });
  const { isMobile } = useCampfireTheme();

  // Determine if this is a rostered session with leave conflict
  const isRosteredWithLeaveConflict = hasLeaveConflict && text === 'Rostered';
  const isRostered = text === 'Rostered' || text === 'To be rostered';

  let displayText = text;
  if (isRosteredWithLeaveConflict) {
    displayText = 'Leave Conflict';
  } else if (hasCustomTimes && isRostered && (customStartTime || customEndTime)) {
    displayText = `${formatShortTime(customStartTime)} - ${formatShortTime(customEndTime)}`;
  }

  return (
    <Button
      onClick={onClick}
      variant='outlined'
      startIcon={
        hasCustomTimes ? <ScheduleIcon style={{ fontSize: '18px' }} /> : <PeopleOutlined style={{ fontSize: '18px' }} />
      }
      disabled={disabled}
      endIcon={<KeyboardArrowDownRounded style={{ fontSize: '18px' }} />}
      classes={{ root: isMobile ? classes.statusContainerMobile : classes.statusContainer }}
      style={{
        color: text === 'Unavailable' ? '#9e9e9e' : '',
        backgroundColor: isRosteredWithLeaveConflict ? '#FFAA63' : undefined,
      }}
    >
      {displayText}
    </Button>
  );
}

export function RosterCompletedStatus({ color = '#ABDC40' }: { color?: string }) {
  return <Box bgcolor={color} width='1rem' height='1rem' borderRadius='50%' margin='auto' />;
}
